import { ICON } from '@/src/general/enums/icons'
import { MailScreen } from '@/src/general/ui/screens/MailScreen'

export default () => <MailScreen textId="user.mail.unsubscribe" icon={ICON.THUMBS_UP} />
